import { useTranslation } from '@rhino-project/core/i18n';
import { AuthForm } from '../../components/auth/AuthForm';
import { LinkButton } from '../../components/buttons';
import { useResetPasswordAction } from '@rhino-project/core/queries';
import { NetworkParamError } from '@rhino-project/core/lib';
import { AuthPage, type AuthPageProps } from './AuthPage';
import { ResetPasswordExpiredPage } from './ResetPasswordExpiredPage';
import { Alert, AlertContent, AlertTitle } from '@heroui/react';
import { useSearch } from '@tanstack/react-router';

export const ResetPasswordPage = (props: AuthPageProps) => {
  const { t } = useTranslation();
  const {
    mutate: resetPasswordAction,
    isPending,
    isSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: { data: { message } = {} } = {} as any,
    error
  } = useResetPasswordAction();

  const paramError = error as NetworkParamError | null;

  const { reset_password_token } = useSearch({ strict: false }) as {
    reset_password_token?: string;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (formValues: any) => {
    resetPasswordAction({ data: { ...formValues, reset_password_token } });
  };

  // Show expired page when the token is invalid or expired
  if (
    paramError?.errors &&
    !Array.isArray(paramError.errors) &&
    paramError.errors.reset_password_token
  ) {
    return <ResetPasswordExpiredPage {...props} />;
  }

  return (
    <AuthPage
      title={t('rhino.frontend.messages.set_new_password')}
      description={t(
        'rhino.frontend.messages.enter_and_confirm_your_new_password'
      )}
      {...props}
    >
      <AuthForm
        passwordField
        passwordConfirmField
        primaryAction={t('rhino.frontend.messages.change_password')}
        isPending={isPending}
        errors={paramError?.errors}
        onSubmit={handleSubmit}
        {...props}
      />
      {isSuccess && (
        <Alert
          status="success"
          className="mt-4 bg-success/10 border border-success/20"
        >
          <AlertContent>
            <AlertTitle>{message}</AlertTitle>
          </AlertContent>
          <LinkButton to="/auth/signin">
            {t('rhino.frontend.messages.sign_in')}
          </LinkButton>
        </Alert>
      )}
    </AuthPage>
  );
};
